import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HardHat, Link2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

export const OfferSiteLink = ({ offer, onChanged }) => {
  const [sites, setSites] = useState([]);
  const [site, setSite] = useState(null);
  const [busy, setBusy] = useState(false);
  const [picking, setPicking] = useState(false);

  useEffect(() => {
    api.listSites().then(setSites).catch(() => {});
    if (offer.site_id) api.getSite(offer.site_id).then(setSite).catch(() => setSite(null));
    else setSite(null);
  }, [offer.site_id]);

  const createFromOffer = async () => {
    setBusy(true);
    try {
      const s = await api.createSiteFromOffer(offer.id);
      toast.success(`Cantiere "${s.name}" creato`);
      onChanged();
    } catch (e) { toast.error(e?.response?.data?.detail || "Errore"); } finally { setBusy(false); }
  };
  const link = async (sid) => {
    if (!sid) return;
    setBusy(true);
    try { await api.linkOffer(sid, offer.id); toast.success("Offerta associata al cantiere"); setPicking(false); onChanged(); }
    finally { setBusy(false); }
  };

  if (site) {
    return (
      <Link to={`/cantieri/${site.id}`} data-testid="offer-site-link" className="inline-flex items-center gap-1.5 text-xs font-semibold px-2 py-1 rounded-md border bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-emerald-100">
        <HardHat className="w-3 h-3" /> Cantiere: {site.name}
      </Link>
    );
  }
  return (
    <span className="inline-flex items-center gap-1.5">
      <button onClick={createFromOffer} disabled={busy} data-testid="create-site-from-offer-button" className="inline-flex items-center gap-1 text-xs font-semibold px-2 py-1 rounded-md border border-slate-200 text-slate-600 hover:border-orange-300 hover:text-orange-700">
        {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <HardHat className="w-3 h-3" />} Crea cantiere
      </button>
      {picking ? (
        <select autoFocus onChange={(e) => link(e.target.value)} onBlur={() => setPicking(false)} data-testid="offer-link-site-select" className="text-xs border border-slate-200 rounded-md px-1.5 py-1 bg-white">
          <option value="">Scegli cantiere…</option>
          {sites.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
        </select>
      ) : (
        <button onClick={() => setPicking(true)} disabled={sites.length === 0} data-testid="offer-link-site-button" title={sites.length ? "Associa a cantiere esistente" : "Nessun cantiere disponibile"} className="inline-flex items-center gap-1 text-xs font-semibold px-2 py-1 rounded-md border border-slate-200 text-slate-600 hover:border-slate-300 disabled:opacity-40">
          <Link2 className="w-3 h-3" /> Associa
        </button>
      )}
    </span>
  );
};
